// NOTE: serverTx.confirmations actually counts the number of blocks AFTER
// the TX was confirmed, so we must check for the precense of blockNumber instead.

export default function isConfirmedServerTx(serverTx) {
  return serverTx.blockNumber != null
}
